import { useEffect, useRef } from 'react';
import { PatientListInfo, PatientMessagesInfo } from 'types';

type Props = {
  info: null | PatientMessagesInfo | PatientListInfo;
  onIntersectionAction: () => void;
  IntersectionObject: React.RefObject<HTMLElement>;
  IntersectionObserverProps: IntersectionObserverInit;
  dependencies: any[];
  scrollLoadingEnabled?: boolean;
};

export const useIntersectionObserver = ({
  info,
  onIntersectionAction,
  IntersectionObject,
  IntersectionObserverProps,
  dependencies,
  scrollLoadingEnabled = true,
}: Props) => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  useEffect(() => {
    observerRef.current = new IntersectionObserver((entries) => {
      const fetchNextPage =
        scrollLoadingEnabled && entries[0].isIntersecting && info && !info.last && IntersectionObject.current;
      if (fetchNextPage) {
        onIntersectionAction();
        IntersectionObject.current && observerRef?.current?.disconnect();
      }
    }, IntersectionObserverProps);

    if (observerRef.current && IntersectionObject.current) {
      observerRef.current.observe(IntersectionObject.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, dependencies);
};
